import { PrepareLink } from "./PrepareLink";

export const renderLeaf = (props: any) => {
  const { attributes, children, leaf } = props;
  if (leaf.prepareLink) {
    return <PrepareLink {...props} />;
  }

  let entireChildren = children;
  if (leaf.strong) {
    entireChildren = <strong>{entireChildren}</strong>;
  }
  if (leaf.emphasis) {
    entireChildren = <em>{entireChildren}</em>;
  }
  if (leaf.underline) {
    entireChildren = <u>{entireChildren}</u>;
  }
  return <span {...attributes}>{entireChildren}</span>;
};
